import { useContext, useEffect, useState } from "react"
import { AppContext } from "../context/context"

const UiTooltip = ({ children, title }) => {

    const { tooltips, setTooltips } = useContext(AppContext)

    let [id] = useState(crypto.randomUUID())
    // let [tp, setTp] = useState(null)

    const createTp = () => {

        try {

            let el = document.getElementById(id)
            let tp = new window.bootstrap.Tooltip(el)


            setTooltips(list => [...list, tp])

        }
        catch (err) {
            console.log("ERROR AT UI TOOLTIP", err)
        }


    }





    // useEffect(() => {
    //     createTp()
    //     return (() => {
    //         // console.log("DISPOSING TOOLTIP", id)
    //     })
    // }, [])
    
    useEffect(() => {
        createTp()

        return () => {
            try {
                // find and dispose just this tooltip by id
                let el = document.getElementById(id)
                if (el) {
                    let tp = window.bootstrap.Tooltip.getInstance(el)
                    if (tp) tp.dispose()
                }
                // remove from global tooltips array
                setTooltips(list => list.filter(x => {
                    try {
                        return x._element?.id !== id
                    } catch {
                        return true
                    }
                }))
            }
            catch (err) {
                console.log("ERROR DISPOSING TOOLTIP", err)
            }
        }
    }, [])



    return (


        <div id={id} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={title}>
            {children}
        </div>





    )

}

export default UiTooltip